import { deleteRequest, getRequest, postRequest } from 'features/common'
import settings from 'settings'
import { Bookmark } from '../types'

function baseUrl() {
  const { workspaceApiUrl } = settings
  return `${workspaceApiUrl}/connections`
}

export const getBookmarks = async (): Promise<Bookmark[]> => {
  const url = `${baseUrl()}/bookmarks`
  return await getRequest(url)
}

export const createBookmark = async (connectionId: string, bookmark?: Bookmark): Promise<void> => {
  const url = `${baseUrl()}/${connectionId}/bookmarks`
  await postRequest(url, bookmark || {})
}

export const deleteBookmark = async (connectionId: string, bookmark?: Bookmark): Promise<void> => {
  const url = `${baseUrl()}/${connectionId}/bookmarks`
  await deleteRequest(url, {
    headers: {
      'Content-Type': 'application/json'
    },
    body: bookmark ? JSON.stringify(bookmark) : undefined
  })
}
